<template>
    <v-modal-slot @closed="emitClosedEvent">
        <template v-slot:modal-title>
            <span class="badge bg-dark" v-if="!!clientNumber">{{ clientNumber }}</span>&nbsp;
            <span class="badge bg-success" v-if="!!entity?.name">{{ entity?.name }}</span>&nbsp;-
            <span class="badge bg-primary" v-if="!!expedientName">{{ expedientName }}</span>
        </template>

        <template v-slot:modal-content v-if="expedientStatuses.length > 0">
            <div class="d-flex">
                <v-expedient-statuses-timeline :statuses="expedientStatuses"
                                               :only-view="true">
                </v-expedient-statuses-timeline>

                <div class="button-container ms-auto">
                    <button class="btn btn-secondary ms-3"
                            @click="modalToShow = 'statuses-list-add-modal'"
                            v-if="can('expedient.status.store')">
                        <span class="uq-icon bi-plus"></span>
                    </button>
                </div>
            </div>

            <div class="expedient-observations">
                <div class="user-form row">
                    <div class="col-12">
                        <div class="fw-bold">Observaciones del expediente:</div>
                    </div>

                    <template v-if="can('expedient.update')">
                        <div class="col-9">
                            <div class="form-group">
                            <textarea class="form-control"
                                      type="text"
                                      name="observations"
                                      id="observations"
                                      :maxlength="9999"
                                      v-model="observations">
                            </textarea>
                                <ErrorMessage name="observations"/>
                            </div>
                        </div>

                        <div class="col-3">
                            <button class="btn btn-secondary"
                                    @click="updateExpedientObservations"
                                    v-if="observations !== previousObservations">
                                Guardar
                            </button>
                        </div>
                    </template>

                    <template v-else>
                        <div class="col-12">
                            <div class="form-group">
                                <div v-if="!!observations">{{ observations }}</div>
                                <div v-else>No hay observaciones</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>

        <template v-slot:modal-content v-else>
            <div class="mb-3">
                No hay ningún estado asociado a este expediente.
            </div>

            <div class="button-container">
                <button class="btn btn-secondary"
                        @click="modalToShow = 'statuses-list-add-modal'"
                        v-if="can('expedient.status.store')">
                    <span class="uq-icon bi-plus"></span>
                </button>
            </div>

            <div class="expedient-observations">
                <div class="user-form row">
                    <div class="col-12">
                        <div class="fw-bold">Observaciones del expediente:</div>
                    </div>

                    <template v-if="can('expedient.update')">
                        <div class="col-9">
                            <div class="form-group">
                            <textarea class="form-control"
                                      type="text"
                                      name="observations"
                                      id="observations"
                                      :maxlength="9999"
                                      v-model="observations">
                            </textarea>
                                <ErrorMessage name="observations"/>
                            </div>
                        </div>

                        <div class="col-3">
                            <button class="btn btn-secondary"
                                    @click="updateExpedientObservations"
                                    v-if="observations !== previousObservations">
                                Guardar
                            </button>
                        </div>
                    </template>

                    <template v-else>
                        <div class="col-12">
                            <div class="form-group">
                                <div v-if="!!observations">{{ observations }}</div>
                                <div v-else>No hay observaciones</div>
                            </div>
                        </div>
                    </template>
                </div>
            </div>
        </template>

        <template v-slot:close-button>
            Cerrar
        </template>
    </v-modal-slot>

    <statuses-list-add-modal :expedientId="expedientId" v-if="modalToShow === 'statuses-list-add-modal'"
                             @closed="modalToShow = null;"
                             @expedient-status-added="expedientStatusAdded"></statuses-list-add-modal>
</template>

<script>

import VExpedientStatusesTimeline from "./VExpedientStatusesTimeline";
import VModalSlot from "../../../general/VModalSlot";

import StatusesListAddModal from "../../../statuses/parts/StatusesListAddModal";
import {can} from "../../../../helpers/Permissions";
import {getExpedientStatus, getExpedientObservations, updateExpedientObservations} from "../../../../helpers/requests/RequestsStatuses";
import {getExpedientEntity} from "../../../../helpers/requests/RequestsExpedients";
import * as yup from "yup";
import {Field} from "vee-validate";

export default {
    name: "VExpedientStatusesTimelineShowModal",
    components: {
        VModalSlot,
        VExpedientStatusesTimeline,
        StatusesListAddModal,
        Field,
    },
    props: {
        clientNumber: {
            type: String,
            required: true,
        },
        expedientId: {
            type: Number,
            required: true,
        },
        expedientName: {
            type: String,
            required: true,
        },
    },
    setup() {
        return {
            can,
        }
    },
    data() {
        return {
            loading: false,
            modalToShow: null,
            expedientStatuses: [],
            observations: '',
            previousObservations: '',
            entity: null,
            rules: {
                observations: yup.string().max(200, 'Debe tener como máximo 200 caracteres.'),
            }
        }
    },
    mounted() {
        this.loadStatusesInformation();
        this.observations = this.expedientObservations;
        this.previousObservations = this.expedientObservations;
    },
    methods: {
        emitClosedEvent() {
            this.$emit('closed');
        },
        async loadStatusesInformation() {
            this.loading = true;
            
            this.expedientStatuses = await getExpedientStatus(this.expedientId);

            const observationsResult = await getExpedientObservations(this.expedientId);
            this.observations = observationsResult.data ? observationsResult.data : observationsResult.value;
            this.previousObservations = this.observations
            this.entity = await getExpedientEntity(this.expedientId);

            this.loading = false;
        },
        async expedientStatusAdded() {
            this.modalToShow = null;
            this.expedientStatuses = await getExpedientStatus(this.expedientId);

            this.$emit('expedient-status-added');
        },
        async updateExpedientObservations() {
            const x = await updateExpedientObservations(this.expedientId, this.observations);
            if (x.status === 200) {
                this.previousObservations = this.observations;
                this.$store.dispatch('app/setToastMessage', 'Observaciones actualizadas con éxito');
                this.$emit('expedient-observations-updated');
            } else {
                this.$store.dispatch('app/setToastMessage', 'Algo ha ido mal...');
            }
        }
    },
}
</script>
